import { OIDCState } from "../types/openId";
import { bytesToHex as toHex, randomBytes } from "@noble/hashes/utils";
import * as jose from "jose";

export const generateAndSignKey = async (statePayload: OIDCState) => {
  // Per generar una secret key fes córrer: openssl rand -base64 32
  const key = toHex(randomBytes(32));
  const secret = new TextEncoder().encode(key)
  const jwt = await new jose.SignJWT(statePayload)
    .setProtectedHeader({ alg: 'HS256' })
    .sign(secret)
  return {key, jwt};
}

export const jwtVerifyState = async (state: string, key: string) => {
  const secret = new TextEncoder().encode(key);
  const verifiedJWT = await jose.jwtVerify<OIDCState>(state, secret);
  
  return verifiedJWT;
}